<div class="notification-drawer-overlay" 
     [class.open]="isOpen" 
     (click)="closeDrawer.emit()">
</div>

<div class="notification-drawer" [class.open]="isOpen" (click)="$event.stopPropagation()">
  <div class="drawer-header">
    <div class="header-content">
      <h3>Notifications</h3>
      @if (notifications.length > 0) {
        <div class="header-actions">
          <button class="btn-mark-all" (click)="markAllAsRead()" title="Mark all as read">
            <i class="fas fa-check-double"></i>
          </button>
          <button class="btn-clear-all" (click)="clearAll()" title="Clear all">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      }
    </div>
    <button class="close-btn" (click)="closeDrawer.emit()" title="Close">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="drawer-content">
    @if (notifications.length === 0) {
      <div class="empty-state">
        <div class="empty-icon">
          <i class="fas fa-bell-slash"></i>
        </div>
        <p>No notifications yet</p>
        <span class="empty-subtitle">You'll see new order notifications here</span>
      </div>
    } @else {
      <div class="notifications-list">
        @for (notification of notifications; track notification.id) {
          <div class="notification-item" 
               [class.unread]="!notification.isRead"
               (click)="onNotificationClick(notification)">
            <div class="notification-content">
              <div class="notification-header">
                <div class="notification-title">
                  <i class="fas fa-shopping-cart"></i>
                  <span>New Order Received</span>
                  @if (!notification.isRead) {
                    <span class="unread-indicator"></span>
                  }
                </div>
                <button class="delete-btn" 
                        (click)="deleteNotification($event, notification.id)"
                        title="Delete notification">
                  <i class="fas fa-times"></i>
                </button>
              </div>
              
              <div class="notification-body">
                <div class="order-info">
                  <div class="order-id">
                    <strong>Order ID:</strong> {{ notification.orderId.substring(0, 8) }}...
                  </div>
                  <div class="product-name">
                    <i class="fas fa-box"></i>
                    {{ getProductNames(notification) }}
                  </div>
                  <div class="order-time">
                    <i class="fas fa-clock"></i>
                    {{ formatTime(notification.orderDate) }}
                  </div>
                  <div class="order-amount">
                    <strong>Amount:</strong> ₹{{ notification.totalAmount }}
                  </div>
                </div>
              </div>

              <div class="notification-footer">
                <span class="timestamp">{{ formatDateTime(notification.orderDate) }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>

